import { Component, OnInit, afterRender } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
declare var $: any;
declare var Swiper: any; 
@Component({
  selector: 'app-social-link',
  templateUrl: './sociallink.component.html',
  styleUrls: ['./sociallink.component.scss']
})
export class sociallinkComponent implements OnInit {
  sociallinks: any;
  sociallinkspath: any;
  mobView: boolean = false;

  constructor(
    private homeService : HomeService,
    private routes: ActivatedRoute,
  ) {
    		this.routes.queryParams.subscribe(params => {
			if (params['view-type'] === 'mobile') {
			  this.mobView = true;
			} else {
			  //this.mobView = window.innerWidth <= 768;
			}
		  });

    afterRender(() => {
      if ($(".slider-Logo").length) {
        var avnLogo123 = new Swiper('.slider-Logo .swiper-container', {
          loop: false,
          speed: 800,
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.logo-next',
            prevEl: '.logo-prev',
          },
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 30
            },
            767: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 0
            }
          },
        });
  
      }
    });
  }
  ngOnInit(): void {
    this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];

      this.homeService.getsociallinks(model).subscribe(data => {
        this.sociallinks = data._result;
        this.sociallinkspath = data.path;


      });
    });
  }
}
